<app-dialog-header title="Change Duration" (closeClicked)="cancel()">
</app-dialog-header>


<mat-dialog-content class="fullscreen-dialog">
  <div class="container">

    <p>You can adjust the duration of a ticket using the field below.</p>
    <mat-form-field>
      <mat-label>Duration</mat-label>
      <input [formControl]="durationControl" matInput min="1" type="number">
      <span matSuffix>minutes</span>

      @if (durationControl.invalid) {
        <mat-error>Maximum duration 720 minutes</mat-error>
      }
    </mat-form-field>

    <p>The button below will recalculate the duration based on the SMV values of associated schedules.</p>
    <div class="booking-warning">Warning: Follow-on visits may not have Schedules with which to calculate duration.
    </div>
    <button (click)="resetDuration()" color="primary" mat-flat-button>Recalculate Duration From Schedules
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="dialogRef.close()" mat-flat-button
    type="button">{{ 'scheduler.general.cancel' | translate }}
  </button>
  <button (click)="updateDuration()" color="primary" mat-flat-button
    type="submit">{{ 'scheduler.general.saveChanges' | translate }}
  </button>
</mat-dialog-actions>
